"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M23.71,12.88H16.62a.29.29,0,0,0-.29.29v5a.29.29,0,0,0,.29.29h7.09a.29.29,0,0,0,.29-.29v-5A.29.29,0,0,0,23.71,12.88ZM23,16.45v1.44H21.42V16.45H23V14.92H21.42v1.52H19.89V14.92H18.36v1.53h1.53v1.44H18.36V16.45H16.91V14.91h1.45V13.46h1.53v1.45h1.53V13.46H23v1.45h.47v1.54Z",
    style: {
      fill: '#014864'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.79,12.32a.44.44,0,0,0-.44.44v9.59a.44.44,0,0,0,.44.44.44.44,0,0,0,.43-.44V12.76A.44.44,0,0,0,15.79,12.32Z",
    style: {
      fill: '#014864'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16,6.73a.44.44,0,0,0-.63,0L10.59,12H5.84a.45.45,0,0,0,0,.9h4.95a.44.44,0,0,0,.33-.15l4.94-5.39A.44.44,0,0,0,16,6.73Z",
    style: {
      fill: 'none'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.79,11.56a1.16,1.16,0,0,1,1,.56h4.8V12A10.79,10.79,0,1,0,10.79,22.79a10.69,10.69,0,0,0,3.8-.71V12.76A1.2,1.2,0,0,1,15.79,11.56Zm-5,1.34H5.84a.45.45,0,0,1,0-.9h4.75L15.4,6.75a.44.44,0,0,1,.63,0,.44.44,0,0,1,0,.63l-4.94,5.39A.44.44,0,0,1,10.79,12.9Z",
    style: {
      fill: '#024965'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17,20.82a11.77,11.77,0,0,0,1.79-1.59H17Z",
    style: {
      fill: '#024965'
    }
  }));
};

exports["default"] = _default;